/**
 * Terms of Service is now centralized on the hub (uliunai.com/terms). This page
 * is a redirect stub so old bookmarks/links forward to the canonical document.
 */
export default function TermsOfService() {
  useEffect(() => {
    window.location.replace('https://uliunai.com/terms');
  }, []);

  return (
    <div className="min-h-screen bg-black text-gray-300 flex items-center justify-center px-4">
      <p className="text-center text-gray-400">
        Redirecting to{' '}
        <a href="https://uliunai.com/terms" className="text-red-400 hover:text-red-300 transition-colors">
          uliunai.com
        </a>
        …
      </p>
    </div>
  );
}
